var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.06648 6.06549C7.19548 6.20883 7.25998 6.37366 7.25998 6.55999C7.25998 6.74633 7.19548 6.91116 7.06648 7.05449L2.93848 11.1825C2.79515 11.3115 2.63031 11.376 2.44398 11.376C2.25765 11.376 2.09281 11.3115 1.94948 11.1825C1.82048 11.0392 1.75598 10.8743 1.75598 10.688C1.75598 10.5017 1.82048 10.3368 1.94948 10.1935L5.60448 6.55999L1.94948 2.92649C1.82048 2.78316 1.75598 2.61833 1.75598 2.43199C1.75598 2.24566 1.82048 2.08082 1.94948 1.93749C2.09281 1.80849 2.25765 1.74399 2.44398 1.74399C2.63031 1.74399 2.79515 1.80849 2.93848 1.93749L7.06648 6.06549Z",
    fill: "#003768"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.88,
    height: 12,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.380005 12.56)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.aacf18df3d05b0ce645485ff23ac941d.svg";
export { ForwardRef as ReactComponent };